<style scoped="scoped" lang="scss">
.container {
  padding-left: 24px;
  padding-right: 24px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  .table-container {
    margin-top: 10px;

    // 标签
    .tag-container {
      display: flex;
      align-items: center;
      justify-content: space-between;

      // 左侧
      .left {
        display: flex;
        align-items: center;

        .icon {
          display: inline-block;
          width: 5px;
          height: 16px;
          background: #419fff;
        }

        .txt {
          display: inline-block;
          font-weight: 400;
          font-size: 16px;
          color: #303133;
          margin-left: 12px;
        }
      }

      // 右侧
      .right {
        display: flex;
        align-items: center;
      }
    }

    // 左侧分页
    .list-page {
      margin-top: 8px;
      display: flex;
      flex-direction: row-reverse;
    }
  }

  .param-container {
    height: 100%;

    .table {
      margin-top: 10px;
    }
  }

  .gk-html {
    margin-top: 10px;
    font-size: 12px;
    text-align: center;
    border: none !important;
  }

  .gk-html /deep/ table {
    border-collapse: collapse;
    border-color: rgb(232, 232, 232);
  }

  .gk-html /deep/ table tbody tr:first-child {
    height: 26px;
    font-size: 12px;
    background: rgb(123, 127, 128);
  }

  .gk-html /deep/ table tbody tr:not(:first-child) {
    height: 26px;
    font-size: 12px;
    color: #606672;
  }

  .gy-html {
    margin-top: 10px;
    font-size: 12px;
    text-align: center;
    border: none !important;
  }

  .gy-html /deep/ table {
    border-collapse: collapse;
    border-color: rgb(232, 232, 232);
  }

  .gy-html /deep/ table tbody tr:first-child {
    height: 26px;
    font-size: 12px;
    background: rgb(123, 127, 128);
  }

  .gy-html /deep/ table tbody tr:not(:first-child) {
    height: 26px;
    font-size: 12px;
    color: #606672;
  }

  .tj-html {
    margin-top: 10px;
    font-size: 12px;
    text-align: center;
    border: none !important;
  }

  .tj-html /deep/ table {
    border-collapse: collapse;
    border-color: rgb(232, 232, 232);
  }

  .tj-html /deep/ table tbody tr:first-child {
    height: 26px;
    font-size: 12px;
    background: rgb(123, 127, 128);
  }

  .tj-html /deep/ table tbody tr:not(:first-child) {
    height: 26px;
    font-size: 12px;
    color: #606672;
  }
}

.dialog /deep/ .el-dialog__body {
  overflow: auto;
}
</style>

<template>
  <div style="display: inline;">
    <div class="container">
      <div class="form" style="">
        <el-form :model="conditions" :inline="true" size="mini">
          <el-form-item :label="$t('fashengshijian')">
            <yi_time_input :maxTime="7 * 24 * 3600 * 1000" type="datetimerange" :start.sync="conditions.startTime" :end.sync="conditions.endTime"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="false" :type="'equipment'" :ids.sync="conditions.equipmentId"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getListTable" plain>{{ $t('sousuo') }} </el-button>
            <el-button type="default" @click="reset" plain style="margin-left: 10px;">
              {{ $t('chongzhi') }}
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-if="utils.checkPower('web_process_management_snapshot_batchExport')" @click="batchExportvisible = !batchExportvisible">{{ $t('piliangdaochu') }} </el-button>
            <el-button type="primary" v-if="utils.checkPower('web_process_management_snapshot_batchExport_custom')" @click="customBatchExportvisible = !customBatchExportvisible">{{ $t('piliangdaochu') }} </el-button>
            <el-button type="primary" v-if="utils.checkPower('web_process_management_snapshot_batchExport')" @click="exportListVisible = !exportListVisible">{{ $t('daochujilu') }} </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-container">
        <el-row :gutter="10">
          <!-- 左侧表格 -->
          <el-col :span="18">
            <div class="tag-container">
              <div class="left">
                <span class="icon"></span>
                <span class="txt">{{ $t('huizong') }}</span>
              </div>
            </div>
            <div style="margin-top: 8px;">
              <div class="table">
                <el-table :data="snapshootList.tableData" size="mini" border v-loading="leftTableLoading" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px', 'font-size': '14px' }">
                  <el-table-column :label="$t('xuanze')" width="65">
                    <template scope="scope">
                      <el-radio :label="scope.$index" v-model="selectRow" @change.native="getDetailTable(scope.$index, scope.row)">
                        &nbsp
                      </el-radio>
                    </template>
                  </el-table-column>
                  <el-table-column v-for="(item, index) in snapshootList.tableColumn" :key="index" :prop="item.prop" :sortable="item.sortable" :label="$t(item.label)"> </el-table-column>
                </el-table>
              </div>
              <div class="list-page">
                <el-pagination background @size-change="handleListSizeChange" @current-change="handleListCurrentChange" :current-page="snapshootList.pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :page-size="snapshootList.pagination.pageSize" layout="total,prev, pager, next,sizes" :total="snapshootList.total" />
              </div>
            </div>
          </el-col>
          <!-- 右侧表格 -->
          <el-col :span="6">
            <div class="tag-container">
              <div class="left">
                <span class="icon"></span>
                <span class="txt">
                  <span style="display:flex; flex-direction:row;justify-content:center; flex-wrap:nowrap;align-items:center">
                    {{ $t('xiangqing') }}
                    <p :key="key" style="font-size:10px;margin-left: 5px;" v-if="this.selectRow">
                      <!--											{{this.dateFormat(conditions.startTime)}}-{{this.dateFormat(conditions.endTime)}}-->
                      {{ startTime }}{{ character }}{{ endTime }}
                    </p>
                  </span>
                </span>
              </div>
            </div>
            <div style="margin-top:8px;width: 100%;">
              <div>
                <el-table v-loading="rightTableLoading" :key="key" :data="snapshootDetailsList.tableData.slice((snapshootDetailsList.pagination.currentPage - 1) * snapshootDetailsList.pagination.pageSize, snapshootDetailsList.pagination.currentPage * snapshootDetailsList.pagination.pageSize)" size="mini" border style="width: 100%" max-height="500" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px', 'font-size': '14px' }">
                  <el-table-column v-for="(item, index) in snapshootDetailsList.tableColumn" :key="index" :prop="item.prop" :sortable="item.sortable" :label="$t(item.label)">
                    <template slot-scope="scope">
                      <span v-if="item.prop === 'startTime'">
                        {{ dateFormat(scope.row.startTime) }}
                      </span>

                      <span v-else>
                        {{ scope.row[item.prop] }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('caozuo')" width="80">
                    <template slot-scope="scope">
                      <el-button @click="handleParam(scope.row)" type="text" size="small">
                        {{ $t('gongyicanshu') }}
                      </el-button>
                    </template>
                  </el-table-column>
                  <div slot="empty">
                    <span>
                      <img style="width: 84px;height: 52px;margin-top: 68px;" src="../../../../assets/img/web/process_management/empty.svg" />
                    </span>

                    <p style="margin-top: -30px; font-size: 14px;color: #C0C4CC;">
                      <span>{{ $t('qingzaizuofangbiaogexuanzeshuju') }}</span>
                    </p>
                  </div>
                </el-table>
              </div>
              <div style="margin-top: 8px; margin-left: -8px;">
                <el-pagination :current-page="snapshootDetailsList.pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :page-size="snapshootDetailsList.pagination.pageSize" layout="total,sizes" :total="snapshootDetailsList.tableData.length" @size-change="handleDetailSizeChange" @current-change="handleDetailCurrentChange" />
              </div>
              <div style="margin-top: 8px; margin-left: -8px;">
                <el-pagination background small :pager-count="5" :current-page="snapshootDetailsList.pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :page-size="snapshootDetailsList.pagination.pageSize" layout="prev, pager, next" :total="snapshootDetailsList.tableData.length" @size-change="handleDetailSizeChange" @current-change="handleDetailCurrentChange" />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 导出记录dialog -->
      <el-dialog class="dialog" :title="$t('daochujilu')" :visible.sync="exportListVisible" width="70%" destroy-on-close>
        <div class="dialog-scroller">
          <export_list v-if="exportListVisible"></export_list>
        </div>
      </el-dialog>

      <!-- 批量导出dialog -->
      <el-dialog class="dialog" :title="$t('piliangdaochu')" :visible.sync="batchExportvisible" width="30%" destroy-on-close>
        <el-form :model="batchExportForm" :inline="true" size="mini">
          <el-form-item :label="$t('fashengshijian')" required>
            <yi_time_input type="datetimerange" :start.sync="batchExportForm.getBeginTime" :end.sync="batchExportForm.getEndTime" @change="changeOneHourTime"> </yi_time_input>
            <div style="color: red;">最长时间区间: 1小时</div>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_data_select :multiple="false" type="equipment" :ids.sync="batchExportForm.equipmentId" @change="changeEquipmentInExport"></yi_data_select>
          </el-form-item><br />
          <div style="color: #1C9DD6;padding-bottom: 10px;" v-loading="batchExportTotalMouldLoading">{{ $t('gongyicanshu') + '-' + $t('mocishu') + ':' }} {{ batchExportTotalMould }}</div>
        </el-form>
        <div slot="footer">
          <el-button size="mini" type="default" plain @click="batchExportvisible = false">{{ $t('quxiao') }} </el-button>
          <el-button size="mini" type="primary" @click="batchExport" :loading="batchExportLoading">{{ $t('daochu') }} </el-button>
        </div>
      </el-dialog>

      <!-- 批量导出dialog 客制 -->
      <el-dialog class="dialog" :title="$t('piliangdaochu')" :visible.sync="customBatchExportvisible" width="30%" destroy-on-close>
        <el-form :model="batchExportForm" :inline="true" size="mini">
          <el-form-item :label="$t('fashengshijian')" required>
            <yi_time_input type="datetimerange" :start.sync="batchExportForm.getBeginTime" :end.sync="batchExportForm.getEndTime" @change="changeOneHourTime"> </yi_time_input>
            <div style="color: red;">最长时间区间: 1天</div>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_data_select :multiple="false" type="equipment" :ids.sync="batchExportForm.equipmentId" @change="changeEquipmentInExport"></yi_data_select>
          </el-form-item><br />
          <div style="color: #1C9DD6;padding-bottom: 10px;" v-loading="batchExportTotalMouldLoading">{{ $t('gongyicanshu') + '-' + $t('mocishu') + ':' }} {{ batchExportTotalMould }}</div>
        </el-form>
        <div slot="footer">
          <el-button size="mini" type="default" plain @click="customBatchExportvisible = false">{{ $t('quxiao') }} </el-button>
          <el-button size="mini" type="primary" @click="customBatchExport" :loading="batchExportLoading">{{ $t('daochu') }} </el-button>
        </div>
      </el-dialog>

      <!-- 工艺参数dialog -->
      <el-dialog class="dialog" :title="$t(param.title)" :visible.sync="param.visible" :width="param.width" destroy-on-close>
        <div id="export" v-loading="parameterLoading">
          <div style="display: flex;flex-wrap: nowrap;justify-content: center;align-items: center;font-size: 16px;font-weight: bold;margin-bottom: 5px;margin-top: -2px;">
            {{ store.state.organizations[0].name }}
          </div>
          <div>
            <el-descriptions :column="4" :colon="false">
              <el-descriptions-item :label="$t('shebeimingcheng')">{{ info.equipmentName }}</el-descriptions-item>
              <el-descriptions-item :label="$t('mohao')">{{ info.no }}</el-descriptions-item>
              <el-descriptions-item :label="$t('liaohao')">{{ partNo }}</el-descriptions-item>
              <el-descriptions-item :label="$t('shengchanshijian')">{{ dialogTime }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div class="gk-html" v-html="gkHtml" v-watermark="watermarkText"></div>
          <!-- <div class="gy-html" v-html="gyHtml"></div> -->
          <div class="gy-html" v-html="gy" v-watermark="watermarkText"></div>
          <div class="tj-html" v-html="tjHtml" v-watermark="watermarkText"></div>
        </div>
        <div slot="footer">
          <div>
            <el-button size="mini" type="default" plain @click="param.visible = false">{{ $t('quxiao') }} </el-button>
            <el-button size="mini" type="primary" @click="exportPic">{{ $t('daochutupian') }} </el-button>
            <el-button size="mini" type="primary" @click="exportPdf">{{ $t('daochupdf') }} </el-button>
            <el-button size="mini" type="primary" @click="exportExcel">{{ $t('daochuexcel') }} </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script type="text/javascript">
import html2canvas from 'html2canvas';

import jsPDF from 'jspdf';
import check_item from '@@/pages/web/equipment/check/check_item';
import export_list from '@@/pages/web/process_management/snapshot/export_list';

export default {
  name: 'web_process_management_snapshot_list',
  components: {
    check_item,
    export_list
  },
  data() {
    return {
      batchExportvisible: false,
      customBatchExportvisible: false,
      batchExportForm: {},
      batchExportTotalMouldLoading: false,
      batchExportLoading: false,
      batchExportTotalMould: 0,
      exportListVisible: false,
      watermarkText: this.store.state.organizations[0].name + '-' + this.store.state.user.nickname,
      conditions: {
        startTime: this.begin(),
        endTime: this.end()
      }, // 搜索条件
      startTime: '',
      endTime: '',
      lastTime: '',
      character: '-',
      leftTableLoading: false,
      rightTableLoading: false,
      parameterLoading: false,
      key: 0,
      // 左侧表格
      snapshootList: {
        tableColumn: [
          {
            label: 'shebeimingcheng',
            prop: 'equipmentName',
            sortable: false
          },
          {
            label: 'muhao',
            prop: 'no',
            sortable: false
          },
          {
            label: 'mocishu',
            prop: 'count',
            sortable: false
          },
          {
            label: 'mujushengchantongjikaishishijian',
            prop: 'startTime',
            sortable: false
          },
          {
            label: 'mujushengchantongjijieshushijian',
            prop: 'endTime',
            sortable: false
          },
          {
            label: 'haoshi (xiaoshi)',
            prop: 'useTime',
            sortable: false
          }
        ],
        tableData: [],
        total: 0,
        pagination: {
          currentPage: 1,
          pageSize: 10
        }
      },
      // 右侧表格
      snapshootDetailsList: {
        tableColumn: [
          {
            label: 'fashengshijian',
            prop: 'startTime',
            sortable: false // 开启排序
          }
        ],
        tableData: [],
        pagination: {
          currentPage: 1,
          pageSize: 10
        }
      },
      selectRow: '', // 选中行
      info: {},
      param: {
        title: 'gongyicanshu',
        visible: false,
        width: '88%'
      },
      gkHtml: '',
      gyHtml: '',
      tjHtml: '',
      dialogTime: '',
      singleMonitorData: '', //点
      partNo: '' //料号
    };
  },
  directives: {
    watermark: {
      inserted(el, binding) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 300;
        canvas.height = 200;
        ctx.font = '14px Arial';
        ctx.fillStyle = 'rgba(100, 100, 100, 0.3)'; // 水印颜色和透明度
        ctx.rotate((-20 * Math.PI) / 180); // 旋转角度
        let text = binding.value;
        if (text.length > 15) {
          let splitText = [];
          for (let i = 0; i < text.length; i += 15) {
            splitText.push(text.slice(i, i + 15));
          }
          text = splitText.join('\n');
        }
        // 保存初始的 y 坐标
        let y = 100;
        // 计算行高
        let lineHeight = parseInt(ctx.font, 10);
        // 增加行间距，这里设置为 5 像素
        let lineSpacing = 5;
        // 按行绘制文本并添加行间距
        text.split('\n').forEach((line, index) => {
          ctx.fillText(line, 50, y + index * (lineHeight + lineSpacing));
        });
        const imgData = canvas.toDataURL('image/png');
        el.style.backgroundImage = `url(${imgData})`;
        el.style.backgroundRepeat = 'repeat';
      }
    }
  },
  watch: {
    selectRow: {
      handler(n) {
        if (this.snapshootList.tableData.length > 0) {
          const res = this.snapshootList.tableData.filter((item, index) => {
            return index == n;
          });
          this.info = res[0];
        }
      },
      immediate: false,
      deep: true
    }
  },
  computed: {
    gy() {
      try {
        let str = this.gyHtml;
        str = this.base64.decode(str);
        let reg1 = /\[[^\]]*\]/g;
        str.match(reg1) &&
          str.match(reg1).map(code => {
            let c = code.replace('[', '');
            c = c.replace(']', '');
            str = str.replace(code, this.$t(c));
          });

        let reg2 = /\{[^\}]*\}/g;
        str.match(reg2) &&
          str.match(reg2).map(code => {
            let c = code.replace('{', '');
            c = c.replace('}', '');
            if (!this.store.state.eqPoints[this.info.equipmentId][c]) {
              console.log('gongyimobanqueshaodian' + ':' + c);
              return;
            }

            let value = this.singleMonitorData[c];
            if (value == null) {
              str = str.replace(code, '');
            } else {
              const dictTypeCode = this.store.state.eqPoints[this.info.equipmentId][c].dictTypeCode;
              if (dictTypeCode != null && dictTypeCode !== '') {
                str = str.replace(code, this.$t(this.store.state.dictJsonAll[dictTypeCode][parseInt(value)]));
              } else {
                let dataType = this.store.state.eqPoints[this.info.equipmentId][c].dataType;
                if (dataType == 1) {
                  str = str.replace(code, value);
                } else if (dataType == 3) {
                  str = str.replace(code, isNaN(Number(value)) ? value : Number(value).toFixed(0));
                } else {
                  let prec = this.store.state.eqPoints[this.info.equipmentId][c].prec;
                  str = str.replace(code, isNaN(Number(value)) ? value : Number(value).toFixed(prec == null ? 2 : prec));
                }
              }
            }
          });

        return str;
      } catch (error) {
        console.error(error);
      }
    }
  },
  methods: {
    // 批量导出 客制
    customBatchExport() {
      if (!this.batchExportForm.getBeginTime) {
        this.$message.error(this.$t('qishishijian') + this.$t('bitian'));
        return;
      }
      if (!this.batchExportForm.equipmentId) {
        this.$message.error(this.$t('shebeimingcheng') + this.$t('bitian'));
        return;
      }
      if (this.batchExportTotalMould <= 0) {
        this.$message.error(this.$t('bucunzaigongyicanshu'));
        return;
      }
      const start = this.batchExportForm.getBeginTime;
      const end = this.batchExportForm.getEndTime;
      if (start && end) {
        if (end - start > 24 * 60 * 60 * 1000) {
          this.$message.warning('最长时间区间1天');
          return;
        }
      }

      this.batchExportLoading = true;
      this.http
        .post('/web/craft/snapshot/export/batchExport', this.batchExportForm)
        .then(res => {
          this.$message.success('提交导出任务成功, 请关注右上角消息提醒');
          this.batchExportForm = {};
          this.batchExportvisible = false;
          this.batchExportTotalMould = 0;
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.batchExportLoading = false;
        });
    },
    // 批量导出
    batchExport() {
      if (!this.batchExportForm.getBeginTime) {
        this.$message.error(this.$t('qishishijian') + this.$t('bitian'));
        return;
      }
      if (!this.batchExportForm.equipmentId) {
        this.$message.error(this.$t('shebeimingcheng') + this.$t('bitian'));
        return;
      }
      if (this.batchExportTotalMould <= 0) {
        this.$message.error(this.$t('bucunzaigongyicanshu'));
        return;
      }
      const start = this.batchExportForm.getBeginTime;
      const end = this.batchExportForm.getEndTime;
      if (start && end) {
        if (end - start > 60 * 60 * 1000) {
          this.$message.warning('最长时间区间1小时');
          return;
        }
      }

      this.batchExportLoading = true;
      this.http
        .post('/web/craft/snapshot/export/batchExport', this.batchExportForm)
        .then(res => {
          this.$message.success('提交导出任务成功, 请关注右上角消息提醒');
          this.batchExportForm = {};
          this.batchExportvisible = false;
          this.batchExportTotalMould = 0;
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.batchExportLoading = false;
        });
    },
    // 批量导出中的设备调用
    changeEquipmentInExport() {
      if (this.batchExportForm.equipmentId) {
        this.getBatchExportTotalMould();
      }
    },
    // 批量导出中的时间选择器调用
    changeOneHourTime() {
      const start = this.batchExportForm.getBeginTime;
      const end = this.batchExportForm.getEndTime;
      if (start && end) {
        // if (end - start > 3600000) {
        //   this.$message.warning('最长时间区间1小时');
        //   return;
        // }
        this.getBatchExportTotalMould();
      }
    },
    // 查询时间范围内设备的总模次数
    getBatchExportTotalMould() {
      if (this.batchExportForm.getBeginTime && this.batchExportForm.getEndTime && this.batchExportForm.equipmentId) {
        let requestParam = {
          startTime: this.batchExportForm.getBeginTime,
          endTime: this.batchExportForm.getEndTime,
          equipmentId: this.batchExportForm.equipmentId,
          page: 1,
          pageSize: 999
        };

        this.batchExportTotalMouldLoading = true;
        this.http
          .get('/web/craft/snapshoot/page?' + this.qs.stringify(requestParam))
          .then(res => {
            const data = res.data;
            if (data && data.rows && data.rows.length > 0) {
              let totalMould = 0;
              for (let i = 0; i < data.rows.length; i++) {
                totalMould += data.rows[i].count;
              }
              this.batchExportTotalMould = totalMould;
            }
          })
          .catch(err => {
            this.$message.error(this.$t(err));
          })
          .finally(() => {
            this.batchExportTotalMouldLoading = false;
          });
      }
    },
    // 导出图片
    exportPic() {
      html2canvas(document.getElementById('export')).then(canvas => {
        let dataURL = canvas.toDataURL('image/png');
        if (dataURL !== '') {
          var a = document.createElement('a');
          a.download = this.$t('gongyicanshu');
          a.href = dataURL;
          a.click();
        }
      });
    },
    //导出pdf
    exportPdf() {
      html2canvas(document.getElementById('export')).then(canvas => {
        const doc = new jsPDF('landscape');
        doc.addImage(canvas.toDataURL('image/png'), 'PNG', 10, 10, 280, 180);
        doc.save('工艺参数.pdf');
      });
    },
    //导出Excel
    exportExcel() {
      //table标签导出到excel
      //获取table标签
      var tables = document.querySelectorAll('#export table');
      var html = '';
      for (var i = 0; i < tables.length; i++) {
        html += tables[i].outerHTML + '<br/>';
        console.log(html);
        //html的#ffffff转成black
        html = html.replace(/#ffffff/g, 'black');
      }

      var url = 'data:application/vnd.ms-excel;base64,';
      var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body style="color:black"><table>{table}</table></body></html>';
      var base64 = function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      };
      var format = function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      };
      var ctx = { worksheet: 'Sheet1', table: html };
      var link = document.createElement('a');
      link.download = '工艺参数.xls';
      link.href = url + base64(format(template, ctx));
      link.click();
    },
    // 重置
    reset() {
      this.equipmentId = '';
      this.sn = '';
      this.conditions = {
        startTime: this.begin(),
        endTime: this.end()
      };
      this.snapshootList.tableData = [];
      this.snapshootDetailsList.tableData = [];
      this.selectRow = '';
    },
    // 日期转换
    dateFormat(time) {
      const t = new Date(time);
      // 日期格式
      const format = 'Y-m-d h:i:s';
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hours = t.getHours();
      let minutes = t.getMinutes();
      let seconds = t.getSeconds();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      hours = hours > 9 ? hours : `0${hours}`;
      minutes = minutes > 9 ? minutes : `0${minutes}`;
      seconds = seconds > 9 ? seconds : `0${seconds}`;
      const hash = {
        Y: year,
        m: month,
        d: day,
        h: hours,
        i: minutes,
        s: seconds
      };
      return format.replace(/\w/g, o => {
        return hash[o];
      });
    },

    searchPre() {
      this.snapshootList.tableData = [];
      this.snapshootDetailsList.tableData = [];
      this.selectRow = '';
    },

    // 获取左侧表格
    getListTable() {
      this.snapshootDetailsList.pagination.currentPage = 1;
      this.snapshootDetailsList.pagination.pageSize = 10;
      if (!this.conditions.startTime) {
        this.$message.error(this.$t('qishishijian') + this.$t('bitian'));
        return;
      }
      if (!this.conditions.equipmentId) {
        this.$message.error(this.$t('shebeimingcheng') + this.$t('bitian'));
        return;
      }

      let requestParam = {
        ...this.conditions,
        page: this.snapshootList.pagination.currentPage,
        pageSize: this.snapshootList.pagination.pageSize
      };

      this.searchPre();
      this.leftTableLoading = true;
      return this.http
        .get('/web/craft/snapshoot/page?' + this.qs.stringify(requestParam))
        .then(response => {
          this.snapshootList.tableData = response.data.rows;
          this.snapshootList.total = response.data.total;
          for (let i = 0; i < this.snapshootList.tableData.length; i++) {
            this.snapshootList.tableData[i]['useTime'] = (this.snapshootList.tableData[i]['useTime'] / 3600).toFixed(1);
            this.snapshootList.tableData[i]['startTime'] = this.snapshootList.tableData[i]['startTime'] == null ? '' : this.dateFormat(this.snapshootList.tableData[i]['startTime']);
            this.snapshootList.tableData[i]['endTime'] = this.snapshootList.tableData[i]['endTime'] == null ? '' : this.dateFormat(this.snapshootList.tableData[i]['endTime']);
            this.snapshootList.tableData[i]['lastTime'] = this.snapshootList.tableData[i]['lastTime'] == null ? '' : this.dateFormat(this.snapshootList.tableData[i]['lastTime']);
          }
        })
        .catch(error => {
          // this.$message.error(error)
        })
        .finally(() => {
          this.leftTableLoading = false;
        });
      if (this.selectRow) {
        this.getDetailTable();
      }
    },
    // 获取右侧表格
    getDetailTable(index, row) {
      this.startTime = row.startTime;
      this.endTime = row.endTime;
      this.selectRow = index;
      let params = {
        pointCode: row.no,
        equipmentId: row.equipmentId,
        startTime: new Date(row.startTime).getTime(),
        endTime: new Date(row.endTime).getTime(),
        page: this.snapshootDetailsList.pagination.currentPage,
        pageSize: this.snapshootDetailsList.pagination.pageSize
      };
      this.rightTableLoading = true;
      return this.http
        .get('/web/craft/snapshoot/details?' + this.qs.stringify(params))
        .then(response => {
          this.snapshootDetailsList.tableData = response.data;
          console.log('vvvvv', this.snapshootDetailsList.tableData);
        })
        .finally(() => {
          this.rightTableLoading = false;
        });
    },
    // 右侧表格页码变化
    handleDetailSizeChange(val) {
      this.snapshootDetailsList.pagination.pageSize = val;
      this.snapshootDetailsList.pagination.currentPage = 1;
    },
    // 右侧表格分页变化
    handleDetailCurrentChange(val) {
      this.snapshootDetailsList.pagination.currentPage = val;
    },
    // 左侧表格页码变化
    handleListSizeChange(val) {
      this.snapshootList.pagination.pageSize = val;
      this.snapshootList.pagination.currentPage = 1;
    },
    // 左侧表格分页变化
    handleListCurrentChange(val) {
      this.snapshootList.pagination.currentPage = val;
    },
    // 工艺参数
    handleParam(row) {
      this.param.visible = true;
      const res = this.snapshootList.tableData.filter((item, index) => {
        return index === this.selectRow;
      });
      let params = {
        equipmentId: res[0]['equipmentId'],
        startTime: row.startTime
      };
      this.parameterLoading = true;
      this.dialogTime = this.dateFormat(row.startTime);
      return this.http
        .get('/web/craft/snapshoot/parameter?' + this.qs.stringify(params))
        .then(response => {
          if (response.data.table === undefined || response.data.table === null) {
            this.$message.error(this.$t('qingpeizhimuban'));
          } else {
            // console.log('response.data.table.gy', response.data.table.gy)
            this.gyHtml = response.data.table.gy;
            this.singleMonitorData = response.data.singleMonitorData;
            this.partNo = this.singleMonitorData["CurrentMaterialNo"];
          }
        })
        .finally(() => {
          this.parameterLoading = false;
        });
    },
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 00:00:00').getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const end = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' 23:59:59').getTime();
      return end;
    }
  }
};
</script>
